import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../Components/ComponentButton';
import AdditionalFields from './AdditionalFields';
import Input from '../../../Components/ComponentInput';
import T from '../../../Locale';
class PageAdditional extends Component {
    constructor(props) {
        super(props);
        this.state = { valueError: false, validated: false };
        this.hasAdditionalData = this.hasAdditionalData.bind(this);
        this.validateAndGo = this.validateAndGo.bind(this);
        this.additionalInformationIsValid = this.additionalInformationIsValid.bind(this);
    }
    hasAdditionalData(key) {
        const { data } = this.props;
        if (!data.additional || typeof data.additional[key] === 'undefined' || !data.additional[key].value.length) {
            return false;
        }
        return true;
    }
    validateAndGo() {
        const { data, goToNextPage } = this.props;
        if (!data.value) {
            this.setState({ valueError: true });
        }
        else if (this.additionalInformationIsValid()) {
            goToNextPage();
        }
        this.setState({ validated: true });
    }
    additionalInformationIsValid() {
        const { data: { type } } = this.props;
        if (type === 'value') {
            if (this.hasAdditionalData('quantity')) {
                return true;
            }
        }
        else if (type === 'vehicle') {
            if (this.hasAdditionalData('vehicleType')
                && this.hasAdditionalData('vin')
                && this.hasAdditionalData('registrationNumber')
                && this.hasAdditionalData('brand')
                && this.hasAdditionalData('model')) {
                return true;
            }
        }
        else if (type === 'property') {
            if (this.hasAdditionalData('addressType')
                && this.hasAdditionalData('address')
                && this.hasAdditionalData('postal')
                && this.hasAdditionalData('city')
                && this.hasAdditionalData('country')
                && this.hasAdditionalData('cadastral')) {
                return true;
            }
        }
        else if (type === 'vessel') {
            if (this.hasAdditionalData('vesselType')
                && this.hasAdditionalData('brand')
                && this.hasAdditionalData('model')
                && this.hasAdditionalData('year')) {
                return true;
            }
        }
        else if (type === 'saving') {
            if (this.hasAdditionalData('company') && this.hasAdditionalData('savingType') && this.hasAdditionalData('number')) {
                return true;
            }
        }
        else if (type === 'insurance') {
            if (this.hasAdditionalData('company') && this.hasAdditionalData('number')) {
                return true;
            }
        }
        else if (type === 'company') {
            if (this.hasAdditionalData('cvr') && this.hasAdditionalData('number')) {
                return true;
            }
        }
        return false;
    }
    render() {
        const { data, setData, goToPreviousPage } = this.props;
        const { valueError, validated } = this.state;
        return (_jsxs("div", { children: [_jsx(AdditionalFields, { data: data, setData: (key, value) => setData(key, value), validated: validated }), _jsx("h5", { children: T.translate('values.value') }), _jsx("p", { children: T.translate('values.valueDescription') }), _jsx(Input, { defaultValue: data.value, error: valueError, onKeyPress: () => this.setState({ valueError: false }), onChange: (value) => setData('value', value), isCurrency: true, required: true }), _jsxs("div", Object.assign({ className: "text-center" }, { children: [_jsx(Button, Object.assign({ classes: "transparent", onClick: goToPreviousPage }, { children: T.translate('misc.previous') })), _jsx(Button, Object.assign({ onClick: this.validateAndGo }, { children: T.translate('misc.next') }))] }))] }));
    }
}
PageAdditional.propTypes = {
    data: PropTypes.object.isRequired,
    goToNextPage: PropTypes.func.isRequired,
    goToPreviousPage: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired
};
export default PageAdditional;
